import { pageView } from '@reverbdotcom/commons/src/elog';

let initialServerRenderComplete = false;

export default (location) => {
  if (initialServerRenderComplete) {
    // Initial pageView (including non-client routed pages) comes from elog_init.js
    pageView(location);

    if (window.ga !== undefined) {
      const urlWithParams = `${location.pathname}${location.search}`;
      window.ga('set', 'page', urlWithParams);
      window.ga('send', 'pageview');
    }
  }

  initialServerRenderComplete = true;
};
